import React, { useState } from 'react';
import { useHistory, useIntl } from 'umi';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/Opinions.scss';
import { Segment, Button, Justify } from 'tea-component';
import Overlay from './Overview';
import Feeds from './Feeds';
import useData from './_hooks';
import { gotoOpinionGame } from '@/pages/home/utils/utils';

export default function Opinions(props: any) {
  const { entityType = 'mobile', gameId } = props;
  const { filterResult } = useData(props);
  const [value, setValue] = useState(1);
  const [value1, setValue1] = useState(1);

  const { formatMessage } = useIntl();

  const data = [
    { text: formatMessage({ id: 'dbi_overview' }), value: '1' },
    { text: formatMessage({ id: 'dbi_detail_feeds' }), value: '2' },
  ];

  const data1 = [
    { text: formatMessage({ id: 'dbi-sm-filter-socialmedia' }), value: '1' },
    { text: formatMessage({ id: 'dbi_detail_games_store' }), value: '2' },
    { text: formatMessage({ id: 'dbi_detail_news_media' }), value: '3' },
  ];

  return (
    <div className="dbi-mobile-games-opinions">
      <Justify
        className="opinions-head-justify"
        left={
          <div className="opinions-head-segment">
            <Segment
              className="segment-light"
              value={value.toString()}
              onChange={(value) => setValue(parseInt(value, 10))}
              options={data}
            />
            {value == 2 ? (
              <Segment
                className="segment-light"
                value={value1.toString()}
                onChange={(value) => setValue1(parseInt(value, 10))}
                options={data1}
              />
            ) : (
              ''
            )}
          </div>
        }
        right={
          <div className="opinions-head-text">
            <Button
              type="link"
              onClick={() => {
                gotoOpinionGame(
                  gameId,
                  entityType,
                  'unified_id',
                  '',
                  '/opinion/Overview/KeyMetrics',
                );
              }}
            >
              {formatMessage({ id: 'dbi_detail_jump_to_options' })}
            </Button>
          </div>
        }
      />
      {value == 1 ? <Overlay {...props} filterResult={filterResult} /> : <Feeds vaule={value1} />}
    </div>
  );
}
